<template>
  <v-data-table
    :server-items-length="totalItems"
    :hide-default-footer="hideFooter"
    :loading="loading"
    :headers="headers ? headers : originHeaders"
    :options.sync="tableOptions"
    :items="violations"
    item-key="id"
    v-model="selected"
    mobile-breakpoint="0"
    loading-text="Đang Tải"
    :footer-props="footerTable"
    disable-sort
  >
    <!-- Ngày -->
    <template #item.date="{ item }">
      {{ item.date | ddmmyyyy }}
    </template>
    <!-- Lớp -->
    <template #item.class="{ item }">
      <router-link style="text-decoration: none" :to="'/class/' + (item.class && item.class.id)">
        <span v-if="item.class">{{ item.class && item.class.title }}</span>
      </router-link>
    </template>
    <!-- Tiết học -->
    <template #item.subject="{ item }">
      {{ item.subject | getSubject }}
    </template>
    <!-- Họ tên -->
    <template #item.student="{ item }">
      <CardStudentName :student="item.student" link />
    </template>
    <!-- Mục -->
    <template #item.type="{ item }">
      <v-chip small label :color="getColor(item.type)" dark
        ><span v-if="item.type">
          {{ item.type === 'violation' ? 'Kỷ luật' : item.type === 'commendation' ? 'Khen thưởng' : '' }}
        </span>
      </v-chip>
    </template>
    <!-- Thao tác -->
    <template #item.action="{ item }">
      <ViolationActions :selected="item" />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import CardStudentName from '@/views/student/components/CardStudentName.vue'
import ViolationActions from './ViolationListActions.vue'

const originHeaders = [
  {
    text: 'Ngày',
    value: 'date',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Lớp',
    value: 'class',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Tiết học',
    value: 'subject',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Họ tên',
    value: 'student',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Mục',
    value: 'type',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Nội dung',
    value: 'description',
    align: 'left',
    sortable: false,
    show: true
  },
  {
    text: 'Thao tác',
    value: 'action',
    align: 'left',
    sortable: false,
    show: true
  }
]

export default {
  data() {
    return {
      originHeaders: originHeaders,
      selected: [],
      tableOptions: {}
    }
  },
  components: {
    ViolationActions,
    CardStudentName
  },
  props: {
    headers: { type: Array, default: () => null },
    hideFooter: { type: Boolean, default: () => false }
  },
  filters: {
    getSubject: subject => {
      if (subject) {
        return subject.title
      } else {
        return '-'
      }
    }
  },
  computed: {
    ...mapState('violation', ['violations', 'totalItems', 'pageText', 'loading']),
    ...mapGetters('auth', ['ownClassIds']),

    footerTable() {
      let footer = {
        'items-per-page-text': 'Khen thưởng kỷ luật mỗi trang',
        'items-per-page-all-text': 'Tất cả',
        'items-per-page': 10,
        'page-text': this.pageText
      }
      if (this.totalItems > 100) {
        footer['items-per-page-options'] = [5, 10, 15]
      }
      return footer
    }
  },
  methods: {
    ...mapActions('violation', ['searchViolations', 'requestPageSettings']),

    getColor(s) {
      if (s === 'violation') return 'orange'
      else return '#46BE8A'
    },
    refresh(query) {
      const params = { ...query }
      if (this.ownClassIds) params['class_in'] = this.ownClassIds
      this.searchViolations(params)
    }
  },
  watch: {
    tableOptions: {
      handler(newOptions, oldOptions) {
        const itemPerPageChanged = newOptions.itemsPerPage !== oldOptions.itemsPerPage
        const pageChanged = newOptions.page !== oldOptions.page
        if (pageChanged || itemPerPageChanged) {
          this.requestPageSettings({
            page: newOptions.page,
            itemsPerPage: newOptions.itemsPerPage
          })
        }
      },
      deep: true
    }
  }
}
</script>

<style></style>
